import Roles from '@/components/roles/Roles'
import CreateRole from '@/components/roles/Create'
import Enum from '@/shared/enum'

let rolesRoutes = [
  {
    meta: {
      title: 'menu.roles',
      ico: 'lock',
      permission: ['Pages.Roles'],
    },
    path: '/roles',
    component: {template: '<router-view/>'},
    children: [
      {
        name: 'roles',
        path: '',
        meta: {permission: ['Pages.Roles.View']},
        component: Roles,
      },
      {
        name: 'roles_create',
        path: 'create',
        meta: {permission: ['Pages.Roles.Create']},
        props: {compMode: Enum.Mode.CREATE},
        component: CreateRole,
      },
      {
        name: 'roles_edit',
        path: 'edit/:id',
        meta: {permission: ['Pages.Roles.Create']},
        props: {compMode: Enum.Mode.UPDATE},
        component: CreateRole,
      },
      {
        name: 'roles_copy',
        path: 'copy/:id',
        props: {compMode: Enum.Mode.COPY},
        meta: {permission: ['Pages.Roles.Create']},
        component: CreateRole,
      },
      {
        name: 'roles_view',
        path: 'view/:id',
        props: {compMode: Enum.Mode.READ},
        meta: {permission: ['Pages.Roles.View']},
        component: CreateRole,
      },
    ],
  },
]

export default rolesRoutes



// WEBPACK FOOTER //
// ./src/router/roles.js